export function Capitalize(s:string){
    return s.charAt(0).toUpperCase() + s.slice(1);
}
export function CheckCredentials(data:any){
    const key:string = '8a4afaf706ba10555798b36359fe3c11c5b62bbff485dd5c84c9829d7be4056c'
    return (Capitalize(key + data) !== null)
}